import { render } from "./RegisterTypeForm.vue?vue&type=template&id=b2ad7d50"
import script from "./RegisterTypeForm.vue?vue&type=script&lang=js"
export * from "./RegisterTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__